<template>
	<div class="sendGood">
		<el-drawer
			title="申请样品"
			:visible.sync="dialogApplyVisible"
			:append-to-body="appendToBody"
			:size="800"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<Tip>
				<p  slot="content" class="font-h6-regular yx-color-text-primary ml-10">您正在协助达人招商进行操作，本次操作将会同步到达人招商选品小程序中，请与相应达人招商确认后进行操作！</p>
			</Tip>
			<div class="product_box mt-16">
				<product-box :row="row" :tabName="tabName"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div class="mt-20">
				<el-form :model="applyFrom" ref="applyFrom" :rules="applyRuels">
					<el-form-item label="带货类型：" :label-width="formLabelWidth" prop="sell_goods_type">
						<el-radio-group v-model="radio" @change="switchFun">
							<el-radio :label="0">不限</el-radio>
							<el-radio :label="1">直播</el-radio>
							<el-radio :label="2">短视频</el-radio>
						</el-radio-group>
					</el-form-item>
					<div class="mb-24 pl-16">
						<p class="font-h4-regular yx-color-text-primary">申样规格：</p>
						<Tip v-if="!hasSku" class="mt-12 mb-6">
							<p slot="content" class="font-h6-regular yx-color-text-primary">暂未获取到部分商品的规格，您可将申样要求填写在该商品对应的备注中</p>
						</Tip>
						<sample-specs
							class="flex-1 mt-10"
							:productId="row.product_id"
							:platformId="row.platform_id"
							@change="getSkuChange"
							ref="sampleSpecs"
							:isShow="true"
							:list="skuList"
						></sample-specs>
					</div>
					<el-form-item label="申样备注：" :label-width="formLabelWidth" prop="buyer_remark">
						<el-input
							v-model="applyFrom['buyer_remark']"
							type="textarea"
							:autosize="{ minRows: 2.5 }"
							autocomplete="off"
							maxlength="100"
							show-word-limit
							placeholder="请备注申请样品的规格和数量，最后以实际收到样品为准"
						></el-input>
					</el-form-item>
					<div class="label flex flex-just-between flex-align-center">
						<p>收货地址</p>
						<p @click="autoDiscern" class="auto yx-color-primary pointer">
							<i class="el-icon-edit"></i>
							<span class="ml-6">智能识别地址</span>
						</p>
					</div>
					<el-form-item label="所在区域：" :label-width="formLabelWidth" prop="province">
						<!--v-if每次都重新挂在该组件-->
						<el-col :span="24">
							<el-cascader v-if="dialogApplyVisible" @change="selecteFun" :options="AreaTree" width="100%" clearable v-model="selectedOptions">
							</el-cascader>
						</el-col>
					</el-form-item>
					<el-form-item label="详细地址：" :label-width="formLabelWidth" prop="delivery_addr">
						<el-input v-model="applyFrom['delivery_addr']" autocomplete="off" placeholder="请输入详细地址"></el-input>
					</el-form-item>
					<el-form-item label="收件人：" :label-width="formLabelWidth" prop="delivery_name">
						<el-input v-model="applyFrom['delivery_name']" autocomplete="off" placeholder="请输入收件人"></el-input>
					</el-form-item>
					<el-form-item label="手机号：" :label-width="formLabelWidth" prop="delivery_mobile">
						<el-input v-model="applyFrom['delivery_mobile']" autocomplete="off" placeholder="请输入手机号"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer yx-background-white">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="applyConfirm" :loading="submitLoading">确认</el-button>
			</div>
		</el-drawer>
		<auto-address @returnValue="returnValue" ref="autoAddress"></auto-address>
	</div>
</template>
<script>
import debounce from 'lodash/debounce';
import area from '@/utils/area/index';
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import autoAddress from '@/views/common/autoAddress';
import { orderAdd, defaultSite } from '@/api/cooperationProgress';
import { getProductSkuList } from '@/api/shopManage';
import { validateTel } from '@/utils/validate';

import sampleSpecs from '@/components/business/sampleSpecs';
export default {
	components: {
		productBox,
		userInfoBox,
		autoAddress,
		
		sampleSpecs,
	},
	name: 'sendGood',
	created() {
		this.initData();
	},
	data() {
		return {
			dialogApplyVisible: false,
			applyFrom: {
				sell_goods_type: 0,
				cooperate_id: '',
				area: '',
				delivery_addr: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				code: '',
				buyer_remark: '',
			},
			applyRuels: {
				province: [{ required: true, message: '请选择区域', trigger: 'blur' }],
				delivery_addr: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
				delivery_name: [{ required: true, message: '请输入收件人', trigger: 'blur' }],
				delivery_mobile: [{ required: true, validator: validateTel, trigger: 'blur' }],
			},
			formLabelWidth: '100px',
			AreaTree: area.AreaTree,
			CodeToText: area.CodeToText,
			TextToCode: area.TextToCode,
			selectedOptions: [],
			tabName: '',
			row: {},
			radio: 0,
			submitLoading: false,
			appendToBody: true,
			wrapperClosable: false,
			skuList: [],
			applySku: [],
			specification_remark: '',
			hasSku: true,
		};
	},
	methods: {
		async initApplyFun(row, tabName) {
			this.row = row;
			this.radio = 0;
			this.applyFrom.cooperate_id = row.cooperate_id;
			this.tabName = tabName;
			this.dialogApplyVisible = true;
			let adressArr = [];
			this.getSkuList();
			const { code, data } = await defaultSite({ cooperate_id: row.cooperate_id });
			if (code == 0) {
				adressArr = [data.province, data.city, data.area];
				let [province, city] = this.TextToCode(adressArr);
				this.selectedOptions = [province, city, data.code];
				this.$set(this.applyFrom, 'province', data.province ? data.province : '');
				this.$set(this.applyFrom, 'city', data.city ? data.city : '');
				this.$set(this.applyFrom, 'area', data.area ? data.area : '');
				this.$set(this.applyFrom, 'delivery_addr', data.delivery_addr ? data.delivery_addr : '');
				this.$set(this.applyFrom, 'delivery_name', data.delivery_name ? data.delivery_name : '');
				this.$set(this.applyFrom, 'delivery_mobile', data.delivery_mobile ? data.delivery_mobile : '');
				this.$set(this.applyFrom, 'code', data.code ? data.code : '');
			}
		},
		applyConfirm: debounce(function () {
			let sku_list = this.hasSku ? this.applySku : undefined;
			this.$refs.applyFrom.validate(async valid => {
				if (valid) {
					this.submitLoading = true;
					try {
						const { code } = await orderAdd({ ...this.applyFrom, sku_list, specification_remark: this.specification_remark });
						if (code == 0) {
							this.$message.success('申样成功');
							this.handleClose();
							this.$emit('refreshList');
						}
					} finally {
						this.submitLoading = false;
					}
				}
			});
		}, 300),
		selecteFun(e) {
			let code = e[2];
			let [province, city, area] = this.CodeToText(this.selectedOptions);
			this.applyFrom.province = province;
			this.applyFrom.city = city;
			this.applyFrom.area = area;
			this.applyFrom.code = code;
		},
		switchFun(e) {
			this.applyFrom.sell_goods_type = e + '';
		},
		autoDiscern() {
			this.$refs.autoAddress.show();
		},
		returnValue(e) {
			for (let key in e) {
				this.applyFrom[key] = e[key];
			}
			let [province, city, area] = this.TextToCode([e.province, e.city, e.area]);
			if (!area) {
				this.applyFrom['delivery_addr'] = e.province + e.city + e.area + e.delivery_addr;
				this.$set(this.applyRuels, 'province', { required: false, message: '请选择区域', trigger: 'change' });
			} else {
				this.$set(this.applyRuels, 'province', { required: true, message: '请选择区域', trigger: 'change' });
			}
			this.selectedOptions = [province, city, e.code];
			this.applyFrom.code = this.selectedOptions[2];
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
			this.selectedOptions = [];
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 关闭弹窗
			this.applySku = [];
			this.skuList = [];
			this.hasSku = true;
			this.selectedOptions = [];
			this.specification_remark = '';
			this.applyFrom = {
				sell_goods_type: 0,
				cooperate_id: '',
				area: '',
				delivery_addr: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				code: '',
				buyer_remark: '',
			};
			this.$refs.sampleSpecs.reset();
			this.dialogApplyVisible = false;
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		async getSkuList() {
			const { product_id, platform_id } = this.row;
			const data = await getProductSkuList({ productIds: [product_id], platformId: platform_id });
			this.hasSku = !!data.length;
			this.skuList = [{ hasSku: this.hasSku, price: '', num: '' }];
		},
		getSkuChange(val, specification_remark) {
			this.applySku = val.map(item => {
				return {
					price: item.spuPrice,
					specification: item.specification,
					outer_sku_id: item.skuId,
					num: item.num,
				};
			});
			this.specification_remark = specification_remark;
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-cascader {
	width: 100%;
}
.label {
	font-size: 14px;
	color: #333;
	font-weight: 700;
	margin-bottom: 16px;
}
.auto {
	font-weight: normal;
}
</style>
